// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"28":"ed29feca5a61de20d0c4","197":"1dc0fe477b9676ab12c9","692":"779cceeed09d592f4b64","705":"0437b66a136d56a27201","766":"b3a3ca4843fd0965bedd"}[chunkId] + ".min.js";
};